import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import InspectionList from './List';
import InspectionCreate from './Create';
import InspectionDetail from './Detail';
import Common from '../../../../shared/common';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    InspectionDetails: { visible: false, label: '', required: false },
    Location: { visible: false, label: '', required: false },
    InspectionDate: { visible: false, label: '', required: false },
    InspectionTime: { visible: false, label: '', required: false },
    DescriptionOfTest: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.InspectionDetails = { visible: true, label: resources.TestsClauseLabel, required: true };
    fields.Location =  { visible: true, label: languageFile["CONTRACT.WF.INSPECTION.FIELD.LOCATION"], required: true };
    fields.InspectionDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DATE"], required: true };
    fields.InspectionTime =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TIME"], required: true };
    fields.DescriptionOfTest =  { visible: true, label: languageFile["CONTRACT.WF.INSPECTION.FIELD.TEST"], required: true };

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };

    var replyOptions = [
        { value: 'Satisfactory', display: languageFile["OPTIONS.STATUS.Satisfactory"] },
        { value: 'Unsatisfactory', display: languageFile["OPTIONS.STATUS.Unsatisfactory"] }
    ];

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: false };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: false };
    
    return replyFields;
}

class InspectionsRouter extends React.Component {
    constructor(props) {
        super(props);
        if (props.mode === 'SUPPLIER') {
            this.notificationType = '41.3';
            this.documentType = 'Document413';
            if (props.workflowItem.notifyingParty === 'SUPERVISOR') {
                this.documentReplyLogoIDLegacy = Common.GetPartyOrUserCompanyID(props.contract, props.workflowItem.form_CompanyLogo, 'SUPERVISOR', props.userProfile);
            }
            else {
                this.documentReplyLogoIDLegacy = Common.GetPartyOrUserCompanyID(props.contract, props.workflowItem.form_CompanyLogo, 'PM', props.userProfile);
            }
        }
        else if (props.mode === 'SUPERVISOR') {
            this.notificationType = 'SupervisorTestAndInspection';
            this.documentType = 'DocumentSupTestAndInspection';
        }
        else if (props.mode === 'PM') {
            this.notificationType = 'PMTestAndInspection';
            this.documentType = 'DocumentPMTestAndInspection';
        }

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyPeriod = props.workflowItem.replyPeriod;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem} = this.props;

        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<InspectionList
                        {...this.props}
                        
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        notificationType={this.notificationType}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <InspectionCreate
                                {...this.props}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<InspectionDetail
                        {...this.props}
                        mode={this.props.mode}
                        replyPeriod={this.replyPeriod}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        
                        documentType={this.documentType}
                        documentReplyLogoIDLegacy={this.documentReplyLogoIDLegacy}
                        notificationType={this.notificationType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};

const mapStateToProps = store => ({
    //WE NEED userProfile because Common.GetPartyOrUserCompanyID is re-assigned depending on party
    userProfile: store.auth.userProfile
});

export default  connect(mapStateToProps) (InspectionsRouter);